enum ViewPanelSizeEnum {
	HALF = 'half',
	THIRD = 'third',
}

export default ViewPanelSizeEnum;
